export const loginPage = {
  pageTitle: 'Вхід',
  mainTitle: 'Розпочніть своє будівництво з нами',
  text: 'Для входу в особистий кабінет необхідно замовити дзвінок для замовлення проекту, після чого ви отримаєте пароль, який потім зможете змінити.',
  btnText: 'Далі',
  popupIncorrectText: 'Пароль або логін невірний',
};
